import * as React from 'react';

import * as Styled from './card.styles';
import type { CardProps } from './card.types';

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  (
    {
      autoposition,
      children,
      className,
      href,
      isFocusable = true,
      linkProps,
      maxHeight,
      maxWidth,
      minHeight,
      minWidth,
      padding = 'regular',
      selected,
      size = 'small',
      to,
      variant = 'default',
      ...props
    },
    forwardedRef
  ) => {
    const hasLink = Boolean(href || to);

    return (
      <Styled.Card
        $autoposition={autoposition}
        $hasLink={hasLink}
        $maxHeight={maxHeight}
        $maxWidth={maxWidth}
        $minHeight={minHeight}
        $minWidth={minWidth}
        $padding={padding}
        $selected={selected}
        $size={size}
        $variant={variant}
        className={className}
        data-xds="Card"
        ref={forwardedRef}
        role={hasLink ? 'none' : undefined}
        {...props}
      >
        {hasLink && (
          <Styled.CardLink
            $size={size}
            tabIndex={isFocusable ? 0 : -1}
            {...(to && { to })}
            {...(href && { href })}
            {...linkProps}
          />
        )}
        <Styled.CardContent $padding={padding} $size={size}>
          {children}
        </Styled.CardContent>
      </Styled.Card>
    );
  }
);

Card.displayName = 'Card';
